import axios from './axiosinstance';
import axiosRaw from 'axios';
import { APIS, BASE_URL } from '../utils/apifactory';
const getToken = () => localStorage.getItem('token');

const formatAxiosError = (error) => {
    if (error.response?.data) {
        const d = error.response.data;
        if (typeof d === 'string') return d;
        return d.message || d.error || JSON.stringify(d);
    }
    if (error.request && !error.response) {
        return 'No response from server (check network, CORS, or VPN).';
    }
    return error.message || 'Request failed';
};

export const sendCodeApi = (email, password, callBack) => {
    axios
        .post(
            APIS.SEND_CODE_API,
            { email, password },
            { headers: { 'Content-Type': 'application/json' } }
        )
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            console.error('sendCodeApi:', error.response?.data || error.message);
            callBack({ error: formatAxiosError(error) });
        });
};
export const loginApi = (email, password, code, callBack) => {
    axios
        .post(
            APIS.LOGIN_API,
            { email, password, code },
            { headers: { 'Content-Type': 'application/json' } }
        )
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            console.error('loginApi:', error.response?.data || error.message);
            callBack({ error: formatAxiosError(error) });
        });
};
export const getAdminUsersApi = ({ page, perPage }, callBack) => {
    const token = localStorage.getItem('token');

    axios.get(`${APIS.ADMIN_USERS}?page=${page}&perPage=${perPage}`, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const getRolesApi = (callBack) => {
    const token = localStorage.getItem('token');

    axios.get(APIS.GET_ROLES, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const checkUsernameAvailabilityApi = (data, callBack) => {
    const token = localStorage.getItem('token');
    const username = data?.username != null ? String(data.username).trim() : '';

    axios
        .post(
            APIS.CHECK_USERNAME_AVAILABILITY,
            { username },
            {
                headers: {
                    Authorization: `${token}`,
                    'Content-Type': 'application/json',
                },
            }
        )
        .then((response) => callBack(response.data))
        .catch((error) => {
            console.error('Check username availability failed:', error);
            callBack({ error: error.response?.data || { message: error.message } });
        });
};

export const getUsersApi = (paramsOrCallback, callBack) => {
    const token = localStorage.getItem('token');

    if (typeof paramsOrCallback === 'function') {
        axios
            .get(`${APIS.GET_USERS}1&perPage=500`, {
                headers: { Authorization: `${token}` },
            })
            .then((response) => paramsOrCallback(response.data))
            .catch((error) => {
                console.error('Get users failed:', error);
                paramsOrCallback(null);
            });
        return;
    }

    const { page, perPage, role, search } = paramsOrCallback || {};
    const roleParam =
        role !== undefined && role !== null && role !== ''
            ? `&role=${encodeURIComponent(String(role))}`
            : '';
    const searchParam =
        search !== undefined && search !== null && String(search).trim() !== ''
            ? `&search=${encodeURIComponent(String(search).trim())}`
            : '';

    axios
        .get(`${APIS.GET_USERS}${page}&perPage=${perPage}${roleParam}${searchParam}`, {
            headers: { Authorization: `${token}` },
        })
        .then((response) => callBack(response.data))
        .catch((error) => {
            console.error('Get users failed:', error);
            callBack(null);
        });
};

export const deteleUserApi = (userId, callBack) => {
    const token = localStorage.getItem('token');
    axios.delete(`${APIS.DELETE_USER}${userId}`, {
        headers: { Authorization: `${token}` }
    })
    .then(response => callBack(response.data))
    .catch(error => {
        console.error("Delete user failed:", error);
        callBack(null);
    });
};
export const getUserByIdApi = (userId, callback) => {
    const token = localStorage.getItem('token');
    axios.get(`${APIS.GET_USER_DETAIL}${userId}`, {
        headers: { Authorization: `${token}` }
    })
    .then(res => callback(res.data))
    .catch(err => {
        console.error("Get user failed:", err);
        callback(null);
    });
};
export const getProductsApi = (callBack) => {
    const token = localStorage.getItem('token');

    axios.get(APIS.GET_PRODUCTS, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const addAdminProductApi = (data, callBack) => {
    const token = localStorage.getItem('token');

    axios.post(APIS.ADD_ADMIN_PRODUCT, data, {
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const getAdminProductApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.get(`${APIS.GET_ADMIN_PRODUCT}${id}`, {
        headers: {
            Authorization: `${token}`,
        },
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const getProductVariantsApi = ({ productId, page = 1, perPage = 200 }, callBack) => {
    const token = localStorage.getItem('token');
    if (!productId) {
        callBack({ error: { message: 'Missing product id' } });
        return;
    }

    axios
        .get(`${APIS.GET_PRODUCT_VARIANTS}${productId}?page=${page}&perPage=${perPage}`, {
            headers: { Authorization: `${token}` },
        })
        .then((response) => callBack(response.data))
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const deleteAdminProductApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.delete(`${APIS.DELETE_ADMIN_PRODUCT}${id}`, {
        headers: {
            Authorization: `${token}`,
        },
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

/** Multipart upload — uses standalone axios so FormData is not sent as JSON (shared instance sets Content-Type: application/json). */
export const uploadCommonFileApi = (file, fileType, callBack) => {
    const token = localStorage.getItem('token');
    if (!(file instanceof Blob)) {
        callBack({ error: { message: 'Invalid file: expected a File or Blob.' } });
        return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('file_type', fileType);

    axiosRaw
        .post(APIS.UPLOAD_PROFILE_IMAGE, formData, {
            headers: {
                ...(token ? { Authorization: `${token}` } : {}),
            },
            maxBodyLength: Infinity,
            maxContentLength: Infinity,
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const getAllAdminProductsApi = ({ page, perPage, search, user_id }, callBack) => {
    const token = localStorage.getItem('token');
    const searchParam =
        search !== undefined && search !== null && String(search).trim() !== ''
            ? `&search=${encodeURIComponent(String(search).trim())}`
            : '';
    const userParam =
        user_id !== undefined && user_id !== null && String(user_id).trim() !== ''
            ? `&user_id=${encodeURIComponent(String(user_id).trim())}`
            : '';

    axios.get(`${APIS.GET_ALL_ADMIN_PRODUCTS}?page=${page}&perPage=${perPage}${searchParam}${userParam}`, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const getItemsApi = (callBack) => {
    const token = localStorage.getItem('token');

    axios.get(APIS.GET_ITEMS, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const getAllAdminSelfiesApi = ({ page, perPage, search }, callBack) => {
    const token = localStorage.getItem('token');
    const searchParam =
        search !== undefined && search !== null && String(search).trim() !== ''
            ? `&search=${encodeURIComponent(String(search).trim())}`
            : '';

    axios
        .get(`${APIS.GET_ALL_ADMIN_SELFIES}?page=${page}&perPage=${perPage}${searchParam}`, {
            headers: { Authorization: `${token}` },
        })
        .then((response) => callBack(response.data))
        .catch((error) => {
            console.error('Get admin selfies failed:', error);
            callBack({ error: error.response?.data || { message: error.message } });
        });
};

export const addAdminSelfieApi = (data, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .post(APIS.ADD_ADMIN_SELFIE, data, {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'application/json',
            },
        })
        .then((response) => callBack(response.data))
        .catch((error) => {
            console.error('Add admin selfie failed:', error);
            callBack({ error: error.response?.data || { message: error.message } });
        });
};

export const editAdminSelfieApi = (id, data, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .put(`${APIS.EDIT_ADMIN_SELFIE}${id}`, data, {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'application/json',
            },
        })
        .then((response) => callBack(response.data))
        .catch((error) => {
            console.error('Edit admin selfie failed:', error);
            callBack({ error: error.response?.data || { message: error.message } });
        });
};

export const getAdminSelfieApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .get(`${APIS.GET_ADMIN_SELFIE}${id}`, {
            headers: { Authorization: `${token}` },
        })
        .then((response) => callBack(response.data))
        .catch((error) => {
            console.error('Get admin selfie failed:', error);
            callBack({ error: error.response?.data || { message: error.message } });
        });
};

export const deleteAdminSelfieApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .delete(`${APIS.DELETE_ADMIN_SELFIE}${id}`, {
            headers: { Authorization: `${token}` },
        })
        .then((response) => callBack(response.data))
        .catch((error) => {
            console.error('Delete admin selfie failed:', error);
            callBack({ error: error.response?.data || { message: error.message } });
        });
};

/** @deprecated Use getAllAdminSelfiesApi — returns array for legacy callers */
export const getSelfiesApi = (callBack) => {
    getAllAdminSelfiesApi({ page: 1, perPage: 500 }, (res) => {
        if (res?.error || res?.success === false) {
            callBack([]);
            return;
        }
        const list = res?.data?.data;
        callBack(Array.isArray(list) ? list : []);
    });
};
export const getCartApi = (paramsOrCallback, callBack) => {
    // Backwards compatible: getCartApi(cb) OR getCartApi({page, perPage}, cb)
    const params =
        typeof paramsOrCallback === 'function' ? { page: 1, perPage: 10 } : (paramsOrCallback || {});
    const cb = typeof paramsOrCallback === 'function' ? paramsOrCallback : callBack;
    if (typeof cb !== 'function') return;

    const token = localStorage.getItem('token');
    const page = params?.page ?? 1;
    const perPage = params?.perPage ?? 10;

    axios
        .get(`${APIS.GET_ALL_ADMIN_CARTS}?page=${page}&perPage=${perPage}`, {
            headers: { Authorization: `${token}` },
        })
        .then((response) => cb(response.data))
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                cb({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                cb({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                cb({ error: 'Error: ' + error.message });
            }
        });
};
export const getAllAdminBrandsApi = ({ page, perPage, search }, callBack) => {
    const token = localStorage.getItem('token');
    const searchParam =
        search !== undefined && search !== null && String(search).trim() !== ''
            ? `&search=${encodeURIComponent(String(search).trim())}`
            : '';

    axios
        .get(`${APIS.GET_ALL_ADMIN_BRANDS}?page=${page}&perPage=${perPage}${searchParam}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

/** Loads brands as an array (large page) for dropdowns and legacy callers. */
export const getBrandsApi = (callBack) => {
    getAllAdminBrandsApi({ page: 1, perPage: 500 }, (res) => {
        if (res?.error || res?.success === false) {
            callBack([]);
            return;
        }
        const pageData = res?.data;
        const rows = pageData?.data;
        callBack(Array.isArray(rows) ? rows : []);
    });
};
export const getHapperApi = (callBack) => {
    const token = localStorage.getItem('token');

    axios.get(APIS.GET_HAPPER_VARIABLE, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const getCreditCodesApi = (callBack) => {
    const token = localStorage.getItem('token');

    axios.get(APIS.GET_CREDIT_CODES, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const getAllAdminCategoriesApi = ({ page, perPage, search }, callBack) => {
    const token = localStorage.getItem('token');
    const searchParam =
        search !== undefined && search !== null && String(search).trim() !== ''
            ? `&search=${encodeURIComponent(String(search).trim())}`
            : '';

    axios
        .get(`${APIS.GET_ALL_ADMIN_CATEGORIES}?page=${page}&perPage=${perPage}${searchParam}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

/** Loads categories (array) for dropdowns — uses admin get-all with a large page size. */
export const getCategoryApi = (callBack) => {
    getAllAdminCategoriesApi({ page: 1, perPage: 500 }, (res) => {
        if (res?.error || res?.success === false) {
            callBack([]);
            return;
        }
        const pageData = res?.data;
        const rows = pageData?.data;
        const arr = Array.isArray(rows) ? rows : [];
        callBack(arr);
    });
};

export const addAdminCategoryApi = (data, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .post(APIS.ADD_ADMIN_CATEGORY, data, {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'application/json',
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const editAdminCategoryApi = (id, data, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .put(`${APIS.EDIT_ADMIN_CATEGORY}${id}`, data, {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'application/json',
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const getAdminCategoryApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .get(`${APIS.GET_ADMIN_CATEGORY}${id}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const deleteAdminCategoryApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .delete(`${APIS.DELETE_ADMIN_CATEGORY}${id}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const getSubcategoriesApi = ({ categoryIds, category_id } = {}, callBack) => {
    if (typeof categoryIds === 'function') {
        getAllAdminSubcategoriesApi({ page: 1, perPage: 500 }, categoryIds);
        return;
    }
    getAllAdminSubcategoriesApi({ page: 1, perPage: 500, categoryIds, category_id }, (res) => {
        if (res?.error || res?.success === false) {
            callBack([]);
            return;
        }
        const pageData = res?.data;
        const rows = pageData?.data;
        callBack(Array.isArray(rows) ? rows : []);
    });
};

export const getAllAdminSubcategoriesApi = ({ page, perPage, search, categoryIds, category_id }, callBack) => {
    const token = localStorage.getItem('token');
    const searchParam =
        search !== undefined && search !== null && String(search).trim() !== ''
            ? `&search=${encodeURIComponent(String(search).trim())}`
            : '';
    const ids = Array.isArray(categoryIds)
        ? categoryIds.filter((id) => id !== undefined && id !== null && String(id).trim() !== '')
        : [];
    let categoryParam = '';
    if (ids.length) {
        categoryParam = ids
            .map((id) => `&category_id=${encodeURIComponent(String(id).trim())}`)
            .join('');
    } else if (
        category_id !== undefined &&
        category_id !== null &&
        String(category_id).trim() !== ''
    ) {
        categoryParam = `&category_id=${encodeURIComponent(String(category_id).trim())}`;
    }

    axios
        .get(
            `${APIS.GET_ALL_ADMIN_SUBCATEGORIES}?page=${page}&perPage=${perPage}${searchParam}${categoryParam}`,
            {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const addAdminSubcategoryApi = (data, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .post(APIS.ADD_ADMIN_SUBCATEGORY, data, {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'application/json',
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const editAdminSubcategoryApi = (id, data, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .put(`${APIS.EDIT_ADMIN_SUBCATEGORY}${id}`, data, {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'application/json',
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const getAdminSubcategoryApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .get(`${APIS.GET_ADMIN_SUBCATEGORY}${id}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const deleteAdminSubcategoryApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .delete(`${APIS.DELETE_ADMIN_SUBCATEGORY}${id}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const createCodeApi = (data, callBack) => {
    const token = localStorage.getItem('token');

    axios.post(APIS.ADD_CREDIT_CODE, data, {
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const sendNotificationApi = (data, callBack) => {
    const token = localStorage.getItem('token');

    axios.post(APIS.SEND_NOTIFICATION_API, data, {
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const createRoleApi = (data, callBack) => {
    const token = localStorage.getItem('token');

    axios.post(APIS.GET_ROLES, data, {
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const updateroleapi = (id, data, callBack) => {
    const token = localStorage.getItem('token');

    axios.put(APIS.GET_ROLES + '/' + id, data, {
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const createBrandApi = (data, callBack) => {
    const token = localStorage.getItem('token');

    axios.post(APIS.ADD_ADMIN_BRAND, data, {
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        },
    })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const updateBrandApi = (id, data, callBack) => {
    const token = localStorage.getItem('token');

    axios.put(`${APIS.EDIT_ADMIN_BRAND}${id}`, data, {
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        },
    })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const getAdminBrandApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .get(`${APIS.GET_ADMIN_BRAND}${id}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const createSelfieApi = (data, callBack) => addAdminSelfieApi(data, callBack);

export const updateSelfieApi = (id, data, callBack) => editAdminSelfieApi(id, data, callBack);

export const getSelfiesApiForPerid = (id, callBack) => {
    getAdminSelfieApi(id, (res) => {
        if (res?.error || res?.success === false) {
            callBack(res);
            return;
        }
        callBack(res?.data !== undefined ? res.data : res);
    });
};

export const deleteEntrySelfie = (id, callBack) => deleteAdminSelfieApi(id, callBack);
export const deleteBrandsApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.delete(`${APIS.DELETE_ADMIN_BRAND}${id}`, {
        headers: {
            Authorization: `${token}`,
        },
    })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const getInfluencersApi = async () => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.get(APIS.GET_INFLUENCERS, {
            headers: { Authorization: `${token}` },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error('Response error:', error.response.data);
            throw error.response.data;
        } else if (error.request) {
            console.error('Request error:', error.request);
            throw new Error('Request error: No response received');
        } else {
            console.error('Error:', error.message);
            throw new Error(error.message);
        }
    }
};

export const getBrandsApinew = async () => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.get(`${APIS.GET_ALL_ADMIN_BRANDS}?page=1&perPage=500`, {
            headers: { Authorization: `${token}` },
        });
        const body = response.data;
        const pageData = body?.data;
        const rows = pageData?.data;
        return Array.isArray(rows) ? rows : [];
    } catch (error) {
        if (error.response) {
            console.error('Response error:', error.response.data);
            throw error.response.data;
        } else if (error.request) {
            console.error('Request error:', error.request);
            throw new Error('Request error: No response received');
        } else {
            console.error('Error:', error.message);
            throw new Error(error.message);
        }
    }
};

export const getProductsApiDetails = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.get(APIS.GET_PRODUCTS + '/' + id, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const getSelfiesApidetails = (callBack) => {
    getAllAdminSelfiesApi({ page: 1, perPage: 500 }, (res) => {
        if (res?.error || res?.success === false) {
            callBack([]);
            return;
        }
        const list = res?.data?.data;
        callBack(Array.isArray(list) ? list : []);
    });
};
export const updateProductApi = (id, data, callBack) => {
    const token = localStorage.getItem('token');

    axios.put(APIS.GET_PRODUCTS + '/' + id, data, {
        headers: {
            Authorization: `${token}`,
        },
    })
        .then(response => {
            if (typeof callBack === 'function') {
                callBack(response.data);
            }
        })
        .catch(error => {
            const errMsg = error.response
                ? error.response.data
                : error.request
                    ? 'Request error: No response received'
                    : 'Error: ' + error.message;

            console.error('Update product error:', errMsg);

            if (typeof callBack === 'function') {
                callBack({ error: errMsg });
            }
        });
};

export const CreateProductApi = (data, callBack) => {
    const token = localStorage.getItem('token');

    axios.post(APIS.GET_PRODUCTS, data, {
        headers: {
            Authorization: `${token}`,
            // DO NOT SET 'Content-Type' manually for FormData
        },
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};


export const getAllLinkedProductsApi = ({ page, perPage, user_id, search }, callBack) => {
    const token = localStorage.getItem('token');
    const searchParam =
        search !== undefined && search !== null && String(search).trim() !== ''
            ? `&search=${encodeURIComponent(String(search).trim())}`
            : '';
    const userParam =
        user_id !== undefined && user_id !== null && String(user_id).trim() !== ''
            ? `&user_id=${encodeURIComponent(String(user_id).trim())}`
            : '';

    axios
        .get(
            `${APIS.GET_ALL_LINKED_PRODUCTS}?page=${page}&perPage=${perPage}${searchParam}${userParam}`,
            {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

/** @deprecated Use getAllLinkedProductsApi — kept name for older imports */
export const getItemUserApi = (callBack) => {
    getAllLinkedProductsApi({ page: 1, perPage: 500 }, callBack);
};

export const getLinkedProductApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .get(`${APIS.GET_LINKED_PRODUCT}${id}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const updateLinkItemApi = (id, data, callBack) => {
    console.warn('updateLinkItemApi: no admin update endpoint for linked products');
    callBack({ error: { message: 'Update linked product is not available for this API.' } });
};
export const LinkNewItemApi = (data, callBack) => {
    const token = localStorage.getItem('token');

    axios.post(APIS.ADD_LINKED_PRODUCT, data, {
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        },
    })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const getAdminDetailsApi = (userId, callback) => {
    const token = getToken();
    if (!userId) {
        callback({ error: { message: 'Missing admin id' } });
        return;
    }
    axios
        .get(`${APIS.GET_ADMIN_DETAILS}${userId}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((res) => callback(res.data))
        .catch((err) => {
            console.error('Get admin details failed:', err);
            callback({ error: err.response?.data || { message: err.message } });
        });
};
export const createAdminUserApi = (payload, callback) => {
    const data = {
        first_name: payload.first_name,
        last_name:  payload.last_name,
        email:      payload.email,
        password:   payload.password,
        role:       payload.role
    };

    axios.post(`https://api.happer.fr/api/v1/admin/add-admin`, data, {
        headers: {
            Authorization:  getToken(),
            'Content-Type': 'application/json'
        }
    })
    .then(res => callback(res.data))
    .catch(err => {
        console.error("Create admin user failed:", err);
        callback(null);
    });
};

export const editAdminUserApi = (userId, payload, callback) => {
    const data = {
        first_name: payload.first_name,
        last_name:  payload.last_name,
        email:      payload.email,
        password:   payload.password,
        role:       payload.role
    };

    axios.put(`https://api.happer.fr/api/v1/admin/edit-admin/${userId}`, data, {
        headers: {
            Authorization:  getToken(),
            'Content-Type': 'application/json'
        }
    })
    .then(res => callback(res.data))
    .catch(err => {
        console.error("Edit admin user failed:", err);
        callback(null);
    });
};

export const deleteUserApi = (userId, callback) => {
    const token = getToken();
    axios
        .delete(`${APIS.DELETE_ADMIN_USER}${userId}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((res) => callback(res.data))
        .catch((err) => {
            console.error('Delete failed:', err);
            callback({ error: err.response?.data || { message: err.message } });
        });
};

export const deleteItemApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.delete(APIS.GET_ITEMS + '/' + id, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const deletProductApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.delete(APIS.GET_PRODUCTS + '/' + id, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const deleteLinkItemapi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.delete(`${APIS.DELETE_LINKED_PRODUCT}${id}`, {
        headers: {
            Authorization: `${token}`,
        },
    })
        .then((response) => {
            callBack(response.data);
        })
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const dleteacartApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.delete(APIS.GET_CARTS + '/' + id, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const detailcartApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios
        .get(`${APIS.GET_ADMIN_CART}${id}`, {
            headers: { Authorization: `${token}` },
        })
        .then((response) => callBack(response.data))
        .catch((error) => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const deleteRoleApi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.delete(APIS.GET_ROLES + '/' + id, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const deletecreditcodeapi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.delete(APIS.GET_CREDIT_CODES + '/' + id, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};

export const detailscreditcodeapi = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.get(APIS.GET_CREDIT_CODES + '/' + id, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const getMeDetails = (callBack) => {
    const token = localStorage.getItem('token');

    axios.get(APIS.GET_ME_DETAILS + 'me', {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
export const getAdminDEtails = (id, callBack) => {
    const token = localStorage.getItem('token');

    axios.get(APIS.GET_ME_DETAILS + id, {
        headers: {
            Authorization: `${token}`
        }
    })
        .then(response => {
            callBack(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.error('Response error:', error.response.data);
                callBack({ error: error.response.data });
            } else if (error.request) {
                console.error('Request error:', error.request);
                callBack({ error: 'Request error: No response received' });
            } else {
                console.error('Error:', error.message);
                callBack({ error: 'Error: ' + error.message });
            }
        });
};
const getAuthToken = () => {
    return localStorage.getItem('token');
};

export const sendNotificationToUserApi = async (payload, callback) => {
    try {
        const response = await axios.post(BASE_URL + 'notifications', payload, {
            headers: {
                Authorization: `${getAuthToken()}`,
                'Content-Type': 'application/json',
            },
        });
        callback(response.data);
    } catch (error) {
        callback({ success: false, error: error.message });
    }
};

export const sendNotificationToAllApi = async (payload, callback) => {
    try {
        const response = await axios.post(BASE_URL + 'notifications/back_office/sendAll', payload, {
            headers: {
                Authorization: `${getAuthToken()}`,
                'Content-Type': 'application/json',
            },
        });
        callback(response.data);
    } catch (error) {
        callback({ success: false, error: error.message });
    }
};